// extracted by mini-css-extract-plugin
export default {"wrapper":"oCkOm","wrapper--skeleton":"VW2iT","left":"eWyfo","right":"tA31g","content":"i6emF","icon":"wIqN9","rightIcon":"DV13A","skeleton":"e6i5J","dissolve":"QWLWS"};